import {
  APPROVAL_PROMOCODE_FAILURE,
  APPROVAL_PROMOCODE_REQUEST,
  APPROVAL_PROMOCODE_SUCCESS,
  CREATE_PROMOCODE_FAILURE,
  CREATE_PROMOCODE_REQUEST,
  CREATE_PROMOCODE_SUCCESS,
  DELETE_PROMOCODE_FAILURE,
  DELETE_PROMOCODE_REQUEST,
  DELETE_PROMOCODE_SUCCESS,
  FETCH_ALL_PROMOCODE_FAILURE,
  FETCH_ALL_PROMOCODE_REQUEST,
  FETCH_ALL_PROMOCODE_SUCCESS,
  RESET_APPROVAL_PROMOCODE,
  RESET_CREATE_PROMOCODE,
  RESET_DELETE_PROMOCODE,
  RESET_FETCH_ALL_PROMOCODE,
  RESET_UPDATE_PROMOCODE,
  RESET_VALIDATE_PROMOCODE,
  RESET_VIEW_PROMOCODE,
  UPDATE_PROMOCODE_FAILURE,
  UPDATE_PROMOCODE_REQUEST,
  UPDATE_PROMOCODE_SUCCESS,
  VALIDATE_PROMOCODE_FAILURE,
  VALIDATE_PROMOCODE_REQUEST,
  VALIDATE_PROMOCODE_SUCCESS,
  VIEW_PROMOCODE_FAILURE,
  VIEW_PROMOCODE_REQUEST,
  VIEW_PROMOCODE_SUCCESS,
} from "./PromoCodeType";

// Fetch All
export const fetchAllPromoCodeRequest = (payload) => ({
  type: FETCH_ALL_PROMOCODE_REQUEST,
  payload,
});

export const fetchAllPromoCodeSuccess = (payload) => ({
  type: FETCH_ALL_PROMOCODE_SUCCESS,
  payload,
});

export const fetchAllPromoCodeFailure = (payload) => ({
  type: FETCH_ALL_PROMOCODE_FAILURE,
  payload,
});
export const resetFetchAllPromoCode = () => ({
  type: RESET_FETCH_ALL_PROMOCODE,
});

// View
export const viewPromoCodeRequest = (payload) => ({
  type: VIEW_PROMOCODE_REQUEST,
  payload, // usually an ID
});

export const viewPromoCodeSuccess = (payload) => ({
  type: VIEW_PROMOCODE_SUCCESS,
  payload,
});

export const viewPromoCodeFailure = (payload) => ({
  type: VIEW_PROMOCODE_FAILURE,
  payload,
});
export const resetViewPromoCode = () => ({
  type: RESET_VIEW_PROMOCODE,
});

// Update
export const updatePromoCodeRequest = (payload) => ({
  type: UPDATE_PROMOCODE_REQUEST,
  payload, // usually { id, data }
});

export const updatePromoCodeSuccess = (payload) => ({
  type: UPDATE_PROMOCODE_SUCCESS,
  payload,
});

export const updatePromoCodeFailure = (payload) => ({
  type: UPDATE_PROMOCODE_FAILURE,
  payload,
});
export const resetUpdatePromoCode = () => ({
  type: RESET_UPDATE_PROMOCODE,
});

// Delete
export const deletePromoCodeRequest = (payload) => ({
  type: DELETE_PROMOCODE_REQUEST,
  payload, // usually ID
});

export const deletePromoCodeSuccess = (payload) => ({
  type: DELETE_PROMOCODE_SUCCESS,
  payload,
});

export const deletePromoCodeFailure = (payload) => ({
  type: DELETE_PROMOCODE_FAILURE,
  payload,
});
export const resetDeletePromoCode = () => ({
  type: RESET_DELETE_PROMOCODE,
});


export const createPromoCodeRequest = (payload) => {
  return {
    type: CREATE_PROMOCODE_REQUEST,
    payload, // data you’ll send (promo code details)
  };
};

export const createPromoCodeSuccess = (payload) => {
  return {
    type: CREATE_PROMOCODE_SUCCESS,
    payload, // response data (new promo code details)
  };
};

export const createPromoCodeFailure = (error) => {
  return {
    type: CREATE_PROMOCODE_FAILURE,
    payload: error, // error details
  };
};
export const resetCreatePromoCode = () => ({
  type: RESET_CREATE_PROMOCODE,
});
//Approval Status
export const approvalPromoCodeRequest = (payload) => {
  return {
    type: APPROVAL_PROMOCODE_REQUEST,
    payload, // data you’ll send (promo code details)
  };
};

export const approvalPromoCodeSuccess = (payload) => {
  return {
    type: APPROVAL_PROMOCODE_SUCCESS,
    payload, // response data (new promo code details)
  };
};

export const approvalPromoCodeFailure = (error) => {
  return {
    type: APPROVAL_PROMOCODE_FAILURE,
    payload: error, // error details
  };
};
export const resetApprovalPromoCode = () => ({
  type: RESET_APPROVAL_PROMOCODE,
});


//Promo Code validation
export const validatePromoCodeRequest = (payload) => {
  return {
    type: VALIDATE_PROMOCODE_REQUEST,
    payload, // data you’ll send (promo code details)
  };
};

export const validatePromoCodeSuccess = (payload) => {
  return {
    type: VALIDATE_PROMOCODE_SUCCESS,
    payload, // response data (new promo code details)
  };
};

export const validatePromoCodeFailure = (error) => {
  return {
    type: VALIDATE_PROMOCODE_FAILURE,
    payload: error, // error details
  };
};
export const resetValidatePromoCode = () => ({
  type: RESET_VALIDATE_PROMOCODE,
});
